import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { RxAttachmentsModule } from '@itero/rx-attachments';
import { BiSessionInfo } from '@itero/rx-attachments/lib/models/analytics/BiSessionInfo';
import { FeatureToggle } from '@shared/models/feature-toggle';
import { ProcedureMap } from '@shared/models/procedure-map';
import type { Maybe } from '@/types/globals';
import { RoleTypeEnum } from '@shared/models/role-type';

@Component({
	selector: 'rx-intuitive-attachments-panel',
	templateUrl: './rx-intuitive-attachments-panel.component.html',
	styleUrls: ['./rx-intuitive-attachments-panel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, RxAttachmentsModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RxIntuitiveAttachmentsPanelComponent {
	@Input() attachmentsRxId$!: Observable<Maybe<string>>;
	@Input() companyId$!: Observable<Maybe<number>>;
	@Input() isAttachmentsReadOnly$!: Observable<boolean>;
	@Input() biSessionInfo$!: Observable<BiSessionInfo>;
	@Input() contactId$!: Observable<Maybe<number>>;
	@Input() userRole$!: Observable<RoleTypeEnum>;
	@Input() procedureMap$!: Observable<Maybe<ProcedureMap>>;
	@Input() patientGuid$!: Observable<Maybe<string>>;
	@Input() featureToggles$!: Observable<FeatureToggle[]>;
	@Input() companySoftwareOptions$!: Observable<number[]>;
	@Input() timberUrl$!: Observable<Maybe<string>>;

	@Output() isSafeToClose = new EventEmitter<boolean>();
	@Output() attachmentsListUpdated = new EventEmitter<void>();
}
